import React, { useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
  Outlet,
} from "react-router-dom";
import { I18nProvider, SUPPORTED_LANGS, useI18n } from "./i18n/I18nContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import LegalPage from "./pages/LegalPage";
import ThankYou from "./pages/ThankYou";

function DocumentTitle({ titleKey }) {
  const { t, lang } = useI18n();
  useEffect(() => {
    const title = t(titleKey);
    if (title) document.title = title;
    document.documentElement.lang = lang === "ar" ? "es" : "en";
  }, [t, titleKey, lang]);
  return null;
}

function LangLayout() {
  const location = useLocation();
  const lang = location.pathname.split("/")[1];
  if (!SUPPORTED_LANGS.includes(lang)) {
    return <Navigate to="/ar" replace />;
  }
  return (
    <I18nProvider>
      <div className="min-h-screen flex flex-col bg-white">
        <Header />
        <div className="flex-1">
          <Outlet />
        </div>
        <Footer />
        <CookieBanner />
      </div>
    </I18nProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Navigate to="/ar" replace />} />
        <Route path="/thank_you" element={<ThankYou />} />

        <Route path="/:lang" element={<LangLayout />}>
          <Route
            index
            element={
              <>
                <DocumentTitle titleKey="pages.home_seo_title" />
                <Home />
              </>
            }
          />
          <Route
            path="privacy"
            element={
              <>
                <DocumentTitle titleKey="pages.privacy_seo_title" />
                <LegalPage sectionKey="privacy" testId="privacy-page" />
              </>
            }
          />
          <Route
            path="cookies"
            element={
              <>
                <DocumentTitle titleKey="pages.cookies_seo_title" />
                <LegalPage sectionKey="cookies" testId="cookies-page" />
              </>
            }
          />
          <Route
            path="terms"
            element={
              <>
                <DocumentTitle titleKey="pages.terms_seo_title" />
                <LegalPage sectionKey="terms" testId="terms-page" />
              </>
            }
          />
        </Route>

        <Route path="*" element={<Navigate to="/ar" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
